module.exports = __webpack_public_path__ + "img/fuzzy_data.1fb29b3b.png";